import { makeStyles } from "@material-ui/core";
const useStyles = makeStyles({
  itemCount: {
    fontSize: 14,
  },
  disabledTooltip: {
    pointerEvents: "none !important",
  },
});
export default useStyles;
